import React from 'react';
import './Terms.css';

interface Props {
  onBack?: () => void;
}

export default function PaymentPolicy({ onBack }: Props) {
  return (
    <div className="terms-root">
      <div className="terms-card">
        <div className="terms-header">
          <TermsShieldIcon />
          <div>
            <h1 className="terms-title">Política de Pagos</h1>
            <p className="terms-subtitle">StorSafe · Sistema de Gestión de Bodegas Químicas · Vigente desde 2026</p>
          </div>
        </div>

        <div className="terms-body">

          <section className="terms-section">
            <h2>1. Cobros y Renovación Automática</h2>
            <p>
              Al contratar cualquiera de los planes de StorSafe (Starter, Professional o Enterprise),
              el cobro del período seleccionado (mensual o anual) se realiza al inicio del ciclo de
              facturación. Los planes se renuevan <strong>automáticamente</strong> al finalizar cada
              período hasta que el cliente cancele expresamente su suscripción.
            </p>
            <p>
              El cliente recibirá una notificación por correo electrónico antes de cada renovación.
              El monto facturado corresponde al precio vigente del plan en la fecha de renovación,
              el cual puede ser consultado en <strong>storsafe.app/pricing</strong>.
            </p>
          </section>

          <section className="terms-section">
            <h2>2. Política de No Devoluciones</h2>
            <div className="terms-disclaimer-box">
              <strong>IMPORTANTE:</strong> Una vez iniciado el período contratado (mensual o anual)
              no se realizan devoluciones, reembolsos ni créditos parciales por ningún motivo,
              incluyendo la falta de uso del servicio o la cancelación anticipada de la suscripción.
            </div>
            <p>
              El acceso al servicio continúa disponible hasta el último día del período pagado,
              independientemente de la fecha en que el cliente solicite la cancelación.
            </p>
          </section>

          <section className="terms-section">
            <h2>3. Cancelación</h2>
            <p>
              El cliente puede cancelar su suscripción en cualquier momento desde la sección de
              Configuración dentro del panel de StorSafe. La cancelación es efectiva al finalizar
              el período de facturación vigente y pagado; no genera cargos adicionales ni penalizaciones.
            </p>
            <p>
              Tras la cancelación, los datos del cliente se conservan por un período de 30 días
              adicionales, durante los cuales es posible reactivar la suscripción recuperando
              el acceso completo.
            </p>
          </section>

          <section className="terms-section">
            <h2>4. Métodos de Pago</h2>
            <p>StorSafe acepta los siguientes métodos de pago:</p>
            <ul>
              <li>Tarjeta de crédito (Visa, Mastercard, American Express)</li>
              <li>Tarjeta de débito habilitada para pagos en línea</li>
            </ul>
            <p>
              Los pagos son procesados de forma segura a través de proveedores de pago certificados
              con estándar PCI-DSS. StorSafe no almacena datos de tarjetas en sus servidores.
            </p>
          </section>

          <section className="terms-section">
            <h2>5. Precios e Impuestos</h2>
            <p>
              Todos los precios publicados en <strong>storsafe.app/pricing</strong> están expresados
              en dólares americanos (USD). A los precios listados se sumará el Impuesto al Valor
              Agregado (IVA) vigente según la legislación tributaria ecuatoriana aplicable en la
              fecha de facturación.
            </p>
            <p>
              StorSafe se reserva el derecho de ajustar sus precios con un aviso previo mínimo de
              30 días por correo electrónico. Los cambios de precio aplican a partir de la siguiente
              renovación posterior al aviso.
            </p>
          </section>

          <section className="terms-section">
            <h2>6. Disputas y Contracargos</h2>
            <p>
              Antes de iniciar cualquier disputa o contracargo con su banco o entidad financiera,
              el cliente debe contactar a StorSafe para resolver el inconveniente directamente.
              Nos comprometemos a dar respuesta en un plazo máximo de 5 días hábiles.
            </p>
            <p>
              Los contracargos no justificados pueden resultar en la suspensión inmediata de la cuenta.
            </p>
          </section>

          <section className="terms-section">
            <h2>7. Códigos Promocionales</h2>
            <ul>
              <li>Los códigos promocionales son de uso único por contratación.</li>
              <li>Solo aplican para planes de facturación anual.</li>
              <li>No son acumulables con otras promociones.</li>
              <li>StorSafe se reserva el derecho de activar, desactivar o modificar códigos promocionales en cualquier momento y sin previo aviso.</li>
              <li>Los códigos promocionales no aplican para renovaciones automáticas.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2>8. Contacto</h2>
            <p>
              Para consultas sobre cobros, facturas o esta política de pagos, comuníquese con nosotros:
            </p>
            <ul>
              <li>Correo: <a href="mailto:info@storsafe.app" style={{ color: '#2FBF71' }}>info@storsafe.app</a></li>
              <li>Plataforma: <strong>storsafe.app</strong></li>
            </ul>
            <p>
              Horario de atención: lunes a viernes de 09:00 a 18:00 (hora Ecuador, UTC-5).
            </p>
          </section>

        </div>

        {onBack && (
          <button className="terms-back-btn" onClick={onBack}>
            ← Volver
          </button>
        )}
      </div>
    </div>
  );
}

function TermsShieldIcon() {
  return (
    <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#2FBF71" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 2L3 7v6c0 5.25 3.75 10.15 9 11.25C17.25 23.15 21 18.25 21 13V7L12 2z" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
  );
}
